import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import {
  CoverageCheckupState,
  goToNextStep,
  updateCoverageCheckupState,
} from '../../../store/step';
import Select from '@ramsey-design-system/select';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createSelectOptionSchema } from '../../schema';
import { FormikFormField } from '@frontman/rt-protections-ui';
import { nonRetirementSavingsRange } from '../../../utils/shared';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function NonRetirementSavingsStep(): ReactElement {
  const dispatch = useDispatch();
  const { nonRetirementSavings: nonRetirementSavings } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('how_much_savings');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <CardPadding>
      <CardHeader
        header="How much do you have in (non-retirement) savings?"
        subHeader="This determines your need for two types of coverage."
      />

      <Formik
        initialValues={{ nonRetirementSavings }}
        onSubmit={onSubmit}
        validationSchema={createSelectOptionSchema('nonRetirementSavings')}
      >
        <Form ref={formRef}>
          <FormikFormField<CoverageCheckupState>
            id="nonRetirementSavings"
            name="nonRetirementSavings"
            className="u-spacingBlockMd"
            inputComponent={Select}
            rdsAttributes={{ length: 'lg' }}
          >
            <option value="">Select an Option</option>
            {nonRetirementSavingsRange.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </FormikFormField>
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { NonRetirementSavingsStep };
